import React from "react";
import LoginBox from "./LoginBox";
import LoginFaq from "./LoginFaq";

function Login() {
  return (
    <div>
      {" "}
      <video autoPlay loop muted className="video-1">
        <source src="../assets/images/img/hero_video-1.mp4" type="video/mp4" />
      </video>
      <LoginBox />
      <LoginFaq />
    </div>
  );
}

export default Login;
